import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import Download from '../views/download.vue'
import GBWhatsApp from '../views/GBWhatsApp.vue'
import YoWhatsApp from '../views/YoWhatsApp.vue'
import OGWhatsApp from '../views/OGWhatsApp.vue'
import JTWhatsApp from '../views/JTWhatsApp.vue'
import MBWhatsApp from '../views/MBWhatsApp.vue'
import BlueWhatsAppPlus from '../views/BlueWhatsAppPlus.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import TermsOfService from '../views/TermsOfService.vue'
import DMCA from '../views/DMCA.vue'
import Disclaimer from '../views/Disclaimer.vue'
Vue.use(VueRouter)

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

/** 全站 SEO 规范域名（canonical、sitemap 与此一致） */
const SITE = 'https://gbwatsapk.com'

export const constRoutesPc = [
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: 'FMWhatsApp',
			// title 约 50 字符；主词 FMWhatsApp + 价值点 Safe / Guide
			title: 'FMWhatsApp Download Latest (2026)  ',
			keywords: 'fmwhatsapp, fm whatsapp, fmwhatsapp download, fm whatsapp apk, gbwhatsapp',
			// description 约 155 字符：主词 + 辅助词 + 软 CTA
			description:
				'Download FMWhatsApp latest for Android: themes, privacy, install tips. Compare FM WhatsApp APK v10.10—explore secure chat features, then download when ready.',
			ogDescription:
				'FMWhatsApp latest APK pairs richer themes with practical privacy tools. Follow our FM WhatsApp install walkthrough, compare stock WhatsApp gaps, then download once you are comfortable with MOD trade-offs.',
			link: [{ rel: 'canonical', href: `${SITE}/` }],
		},
		component: Home,
	},
	{
		path: '/download/',
		name: 'en-download',
		meta: {
			appname: 'FMWhatsApp',
			title: 'Page to Download FM WhatsApp APK',
			keywords: 'fmwhatsapp apk download, fm whatsapp apk, fmwhatsapp download, gbwhatsapp apk',
			description:
				'Safe page to download FMWhatsApp APK for Android users. This APK file is scanned and free for download.',
			ogDescription:
				'Safe page to download FMWhatsApp APK for Android users. This APK file is scanned and free for download.',
			link: [{ rel: 'canonical', href: `${SITE}/download/` }],
		},
		component: Download,
	},
	{
		path: '/gbwhatsapp-apk/',
		name: 'gbwhatsapp',
		meta: {
			title: 'GBWhatsApp APK Download Latest Version (2026)',
			keywords: 'gbwhatsapp apk, gb whatsapp download, gbwhatsapp mod android, whatsapp themes apk',
			description:
				'Download GBWhatsApp APK latest for Android: themes, privacy, media extras beyond stock WhatsApp. Learn sideload and backup tips—read guide, then download.',
			ogDescription:
				'GBWhatsApp APK latest pairs deep customization with privacy toggles and larger-send options versus official WhatsApp. Follow backup-first installs, sensible update timing, and source checks before you download.',
			link: [{ rel: 'canonical', href: `${SITE}/gbwhatsapp-apk/` }],
		},
		component: GBWhatsApp,
	},
	{
		path: '/yowhatsapp-apk/',
		name: 'yowhatsapp',
		meta: {
			title: 'YoWhatsApp APK Download Latest Version (2026)',
			keywords: 'yowhatsapp apk, yo whatsapp download, yowhatsapp mod android, lightweight whatsapp mod',
			description:
				'Download YoWhatsApp APK latest for Android: fast UI, privacy tools, stable chats vs stock WhatsApp. Follow install steps—learn fixes, then download when ready.',
			ogDescription:
				'YoWhatsApp APK latest targets Android users who want speed-first messaging plus richer privacy levers than official WhatsApp. Review OTA habits, ban-risk cautions, and backup routines before you sideload YoWhatsApp.',
			link: [{ rel: 'canonical', href: `${SITE}/yowhatsapp-apk/` }],
		},
		component: YoWhatsApp,
	},
	{
		path: '/ogwhatsapp-apk/',
		name: 'ogwhatsapp',
		meta: {
			title: 'OGWhatsApp APK Download Latest Version (2026)',
			keywords: 'ogwhatsapp apk, og whatsapp download, lightweight whatsapp mod, small apk whatsapp',
			description:
				'Download OGWhatsApp APK latest: small-footprint WhatsApp mod on Android. Check install steps, updates, and risks—explore details, then download today.',
			ogDescription:
				'OGWhatsApp APK latest suits low-storage devices that still want privacy tweaks beyond stock WhatsApp. Compare package size, verify publishers, and rehearse backups before you install OGWhatsApp from a trusted page.',
			link: [{ rel: 'canonical', href: `${SITE}/ogwhatsapp-apk/` }],
		},
		component: OGWhatsApp,
	},
	{
		path: '/jtwhatsapp-apk/',
		name: 'jtwhatsapp',
		meta: {
			title: 'JTWhatsApp APK Download Latest Version (2026)',
			keywords: 'jtwhatsapp apk, jt whatsapp download, jtwhatsapp themes, whatsapp mod privacy',
			description:
				'Download JTWhatsApp APK latest for Android: themes, privacy, steady updates beyond stock WhatsApp. Read install + backup guide—download responsibly when ready.',
			ogDescription:
				'JTWhatsApp APK latest blends UI customization with granular privacy options on top of the WhatsApp Android base. Plan backups, verify checksums when offered, and update promptly after major WhatsApp releases.',
			link: [{ rel: 'canonical', href: `${SITE}/jtwhatsapp-apk/` }],
		},
		component: JTWhatsApp,
	},
	{
		path: '/mbwhatsapp-apk/',
		name: 'mbwhatsapp',
		meta: {
			title: 'MBWhatsApp APK Download Latest Version (2026)',
			keywords: 'mbwhatsapp apk, mb whatsapp download, business whatsapp mod, auto reply whatsapp',
			description:
				'Download MBWhatsApp APK latest for Android: broadcasts, auto-replies, chat extras. Review permissions and backups—learn workflow, then download if it fits.',
			ogDescription:
				'MBWhatsApp APK latest focuses on small-business messaging workflows beyond stock WhatsApp. Audit APK sources, segment customer lists responsibly, and keep chats backed up before you adopt MBWhatsApp long term.',
			link: [{ rel: 'canonical', href: `${SITE}/mbwhatsapp-apk/` }],
		},
		component: MBWhatsApp,
	},
	{
		path: '/blue-whatsapp-plus-apk/',
		name: 'bluewhatsappplus',
		meta: {
			title: 'Blue WhatsApp Plus APK Download Latest (2026)',
			keywords: 'blue whatsapp plus apk, blue whatsapp plus download, blue whatsapp themes, whatsapp mod ui',
			description:
				'Download Blue WhatsApp Plus APK for Android: themes, motion UI, status tools. Note sideload safety, install basics—explore features, then download mindfully.',
			ogDescription:
				'Blue WhatsApp Plus APK latest highlights stylized blue interfaces and motion-rich chat chrome on the WhatsApp Android base. Verify file sizes, avoid repacked mirrors, and back up chats before you install Blue Plus.',
			link: [{ rel: 'canonical', href: `${SITE}/blue-whatsapp-plus-apk/` }],
		},
		component: BlueWhatsAppPlus,
	},
	{
		path: '/about/',
		name: 'about',
		meta: {
			title: 'About FMWhatsApp Official',
			keywords: 'fmwhatsapp official, about fmwhatsapp, whatsapp mod editorial, safe guides',
			description:
				'Learn about FMWhatsApp Official: editorial standards, MOD reviews, and safety focus. Explore FM WhatsApp mission—discover how we help readers learn more.',
			ogDescription:
				'FMWhatsApp Official shares how editors verify MOD news and protect readers. Explore FM WhatsApp research standards, transparency habits, and update cadence so you can trust the guidance before you explore mods.',
			link: [{ rel: 'canonical', href: `${SITE}/about/` }],
		},
		component: About,
	},
	{
		path: '/contact/',
		name: 'contact',
		meta: {
			title: 'Contact FMWhatsApp Support',
			keywords: 'contact fmwhatsapp, fmwhatsapp support, whatsapp mod help, feedback',
			description:
				'Contact FMWhatsApp Official: support, partnerships, and content feedback. Share FM WhatsApp page issues—explore channels, then reach out today for quick help.',
			ogDescription:
				'FMWhatsApp Official routes support, corrections, and partnership ideas to the right inbox. Outline FM WhatsApp URLs, expected timelines, and evidence so our team can answer faster and keep guides accurate.',
			link: [{ rel: 'canonical', href: `${SITE}/contact/` }],
		},
		component: Contact,
	},
	{
		path: '/privacy-policy/',
		name: 'privacy-policy',
		meta: {
			title: 'Privacy Policy',
			keywords: 'fmwhatsapp privacy policy, data usage, cookies, user rights',
			description:
				'Read FMWhatsApp privacy policy: cookies, analytics, and user rights explained. Understand FM WhatsApp data practices—review safeguards, learn more today.',
			ogDescription:
				'FMWhatsApp Official privacy copy explains cookies, analytics partners, and opt-out paths. Compare FM WhatsApp data minimization ideas with your jurisdiction, then explore contact options whenever questions remain.',
			link: [{ rel: 'canonical', href: `${SITE}/privacy-policy/` }],
		},
		component: PrivacyPolicy,
	},
	{
		path: '/terms-of-service/',
		name: 'terms-of-service',
		meta: {
			title: 'FMWhatsApp Terms of Service',
			keywords: 'fmwhatsapp terms, terms of service, site rules, legal use',
			description:
				'Review FMWhatsApp terms: acceptable use, disclaimers, and third-party links. Know FM WhatsApp limits, duties—read agreement, explore legal details today.',
			ogDescription:
				'FMWhatsApp Official terms highlight acceptable use, IP respect, and liability caps. Review FM WhatsApp disclaimers beside third-party MOD links, then explore enforcement examples before relying on the site.',
			link: [{ rel: 'canonical', href: `${SITE}/terms-of-service/` }],
		},
		component: TermsOfService,
	},
	{
		path: '/dmca/',
		name: 'dmca',
		meta: {
			title: 'FMWhatsApp DMCA Policy',
			keywords: 'fmwhatsapp dmca, copyright notice, takedown policy, counter notice',
			description:
				'Read FMWhatsApp DMCA policy: notices, timelines, and counter-notice rules. Learn FM WhatsApp copyright steps—explore filing rules, act fairly, and stay clear.',
			ogDescription:
				'FMWhatsApp Official DMCA guidance shows compliant notices, evidence bundles, and counter-notice rights. Gather FM WhatsApp URLs, ownership proof, and sworn statements so copyright reviews stay fair and fast.',
			link: [{ rel: 'canonical', href: `${SITE}/dmca/` }],
		},
		component: DMCA,
	},
	{
		path: '/disclaimer/',
		name: 'disclaimer',
		meta: {
			title: 'Disclaimer',
			keywords: 'fmwhatsapp disclaimer, third party mods, no affiliation, user risk',
			description:
				'Read FMWhatsApp disclaimer: independent guides with no WhatsApp affiliation. Note FM WhatsApp APK risks—review limits carefully, learn protections, explore.',
			ogDescription:
				'FMWhatsApp Official disclaimer stresses independence from Meta and user-assumed APK risk. Study FM WhatsApp backup reminders, jurisdiction limits, then explore safer habits before sideloading any third-party build.',
			link: [{ rel: 'canonical', href: `${SITE}/disclaimer/` }],
		},
		component: Disclaimer,
	},
]

let routes = []
// if (isMobileDevice) {
// 	routes = constRoutesM
// }
// if (!isMobileDevice) {
// 	routes = constRoutesPc
// }

routes = constRoutesPc
export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
